import React from "react";
export default function () {
    return (
        <svg width="200" height="200" viewBox="0 0 200 200">
            <g>
                <path d="M34.2,90.7c-2.7-4.7-10.7-5.4-17.9-1.6S5.4,99.8,8,104.5s10.7,5.4,18,1.6S36.9,95.4,34.2,90.7z" />
                <rect x="33.1" y="23.2" width="1.9" height="71.8" />
            </g>
            <g>
                <path d="M71.2,90.7c-2.7-4.7-10.7-5.4-17.9-1.6S42.4,99.8,45,104.5s10.7,5.4,18,1.6S73.9,95.4,71.2,90.7z" />
                <rect x="70.1" y="23.2" width="1.9" height="71.8" />
            </g>
            <g>
                <path d="M109.2,90.7c-2.7-4.7-10.7-5.4-17.9-1.6S80.4,99.8,83,104.5s10.7,5.4,18,1.6S111.9,95.4,109.2,90.7z" />
                <rect x="108.1" y="23.2" width="1.9" height="71.8" />
            </g>
            <rect x="33" y="23" width="114" height="10" />
            <rect x="33" y="37" width="38" height="10" />
            <g>
                <path d="M173.2,90.7c-2.7-4.7-10.7-5.4-17.9-1.6s-10.9,10.7-8.3,15.4s10.7,5.4,18,1.6S175.9,95.4,173.2,90.7z" />
                <rect x="172.1" y="23.2" width="1.9" height="71.8" />
            </g>
            <rect x="115" y="23" width="59" height="10" />
        </svg>
    );
}
